import { List, Map } from 'immutable'

import {
    transformReportAccessRightsData,
    transformPortfolioAccessRightsData,
    ReportBlockAccessRightRecord,
    ReportTypeAccessRightRecord,
    PortfolioBlockAccessRightRecord,
    PortfolioTypeAccessRightRecord,
} from '../helpers'

import { accessRightsReport, accessRightsPortfolio } from './utils/mockData'

const transformReportAccessRightsDataMock = Map({
    reports: Map({
        admin: ReportTypeAccessRightRecord({
            name: 'admin',
            isDisabled: false,
            isAllowed: true,
            order: 25,
            blocks: Map({
                contracts: ReportBlockAccessRightRecord({
                    name: 'contracts',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 22,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({
                        new: true,
                    }),
                }),
                bisnodeScoring: ReportBlockAccessRightRecord({
                    name: 'bisnodeScoring',
                    defaultLevel: '10,20,30,40',
                    isDisabled: false,
                    order: 11,
                    availableLevels: List(['10', '10,20', '10,20,30', '10,20,30,40']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                regInfo: ReportBlockAccessRightRecord({
                    name: 'regInfo',
                    defaultLevel: '10,20',
                    isDisabled: false,
                    order: 5,
                    availableLevels: List(['10', '10,20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                addresses: ReportBlockAccessRightRecord({
                    name: 'addresses',
                    defaultLevel: '20,40',
                    isDisabled: false,
                    order: 7,
                    availableLevels: List(['20', '20,40']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                indicators: ReportBlockAccessRightRecord({
                    name: 'indicators',
                    defaultLevel: '10,30,50',
                    isDisabled: false,
                    order: 2,
                    availableLevels: List(['10', '10,30', '10,30,50']),
                    parameters: Map({
                        trade: true,
                        debt: true,
                    }),
                    flags: Map({}),
                }),
                syntheticIndicators: ReportBlockAccessRightRecord({
                    name: 'syntheticIndicators',
                    defaultLevel: '10,30,50',
                    isDisabled: false,
                    order: 3,
                    availableLevels: List(['10', '10,30', '10,30,50']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                bisnodeCertificates: ReportBlockAccessRightRecord({
                    name: 'bisnodeCertificates',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 1,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                businessPartners: ReportBlockAccessRightRecord({
                    name: 'businessPartners',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 24,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                companyAsCreditor: ReportBlockAccessRightRecord({
                    name: 'companyAsCreditor',
                    defaultLevel: '10,20',
                    isDisabled: false,
                    order: 21,
                    availableLevels: List(['10', '10,20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                paymentIndex: ReportBlockAccessRightRecord({
                    name: 'paymentIndex',
                    defaultLevel: '10,20,30,40',
                    isDisabled: false,
                    order: 12,
                    availableLevels: List(['10', '10,20', '10,20,30', '10,20,30,40']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                liens: ReportBlockAccessRightRecord({
                    name: 'liens',
                    defaultLevel: '10,20',
                    isDisabled: false,
                    order: 19,
                    availableLevels: List(['10', '10,20']),
                    parameters: Map({}),
                    flags: Map({
                        new: true,
                    }),
                }),
                activities: ReportBlockAccessRightRecord({
                    name: 'activities',
                    defaultLevel: '20',
                    isDisabled: false,
                    order: 9,
                    availableLevels: List(['20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                negativeEvents: ReportBlockAccessRightRecord({
                    name: 'negativeEvents',
                    defaultLevel: '10,20',
                    isDisabled: false,
                    order: 18,
                    availableLevels: List(['10', '10,20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                paymentComparison: ReportBlockAccessRightRecord({
                    name: 'paymentComparison',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 28,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                ownership: ReportBlockAccessRightRecord({
                    name: 'ownership',
                    defaultLevel: '10,20',
                    isDisabled: false,
                    order: 15,
                    availableLevels: List(['10', '10,20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                anotace: ReportBlockAccessRightRecord({
                    name: 'anotace',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 27,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                velikost: ReportBlockAccessRightRecord({
                    name: 'velikost',
                    defaultLevel: '20',
                    isDisabled: false,
                    order: 8,
                    availableLevels: List(['20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                contacts: ReportBlockAccessRightRecord({
                    name: 'contacts',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 6,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                publicTenders: ReportBlockAccessRightRecord({
                    name: 'publicTenders',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 23,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                rolesInCompanies: ReportBlockAccessRightRecord({
                    name: 'rolesInCompanies',
                    defaultLevel: '10,20',
                    isDisabled: false,
                    order: 17,
                    availableLevels: List(['10', '10,20']),
                    parameters: Map({}),
                    flags: Map({
                        new: true,
                    }),
                }),
                dotace: ReportBlockAccessRightRecord({
                    name: 'dotace',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 25,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                certificates: ReportBlockAccessRightRecord({
                    name: 'certificates',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 26,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                basicInformation: ReportBlockAccessRightRecord({
                    name: 'basicInformation',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 4,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                persons: ReportBlockAccessRightRecord({
                    name: 'persons',
                    defaultLevel: '10,20,30,40',
                    isDisabled: false,
                    order: 10,
                    availableLevels: List(['10', '10,20', '10,20,30', '10,20,30,40']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                inspections: ReportBlockAccessRightRecord({
                    name: 'inspections',
                    defaultLevel: '10,30',
                    isDisabled: false,
                    order: 20,
                    availableLevels: List(['10', '10,30']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
            }),
            parameters: Map({
                duns: true,
            }),
        }),
        proverovaci: ReportTypeAccessRightRecord({
            name: 'proverovaci',
            isDisabled: false,
            isAllowed: true,
            order: 65,
            blocks: Map({
                regInfo: ReportBlockAccessRightRecord({
                    name: 'regInfo',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 5,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                addresses: ReportBlockAccessRightRecord({
                    name: 'addresses',
                    defaultLevel: '20',
                    isDisabled: false,
                    order: 7,
                    availableLevels: List(['20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                indicators: ReportBlockAccessRightRecord({
                    name: 'indicators',
                    defaultLevel: '10,30',
                    isDisabled: false,
                    order: 2,
                    availableLevels: List(['10', '10,30']),
                    parameters: Map({
                        trade: true,
                        debt: true,
                    }),
                    flags: Map({}),
                }),
                syntheticIndicators: ReportBlockAccessRightRecord({
                    name: 'syntheticIndicators',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 3,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                bisnodeCertificates: ReportBlockAccessRightRecord({
                    name: 'bisnodeCertificates',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 1,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                companyAsCreditor: ReportBlockAccessRightRecord({
                    name: 'companyAsCreditor',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 21,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                liens: ReportBlockAccessRightRecord({
                    name: 'liens',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 19,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({
                        new: true,
                    }),
                }),
                activities: ReportBlockAccessRightRecord({
                    name: 'activities',
                    defaultLevel: '20',
                    isDisabled: false,
                    order: 9,
                    availableLevels: List(['20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                negativeEvents: ReportBlockAccessRightRecord({
                    name: 'negativeEvents',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 18,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                ownership: ReportBlockAccessRightRecord({
                    name: 'ownership',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 15,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                velikost: ReportBlockAccessRightRecord({
                    name: 'velikost',
                    defaultLevel: '20',
                    isDisabled: false,
                    order: 8,
                    availableLevels: List(['20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                contacts: ReportBlockAccessRightRecord({
                    name: 'contacts',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 6,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                basicInformation: ReportBlockAccessRightRecord({
                    name: 'basicInformation',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 4,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                persons: ReportBlockAccessRightRecord({
                    name: 'persons',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 10,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
            }),
            parameters: Map({
                duns: true,
            }),
        }),
        proverovaciLight: ReportTypeAccessRightRecord({
            name: 'proverovaciLight',
            isDisabled: false,
            isAllowed: true,
            order: 107,
            blocks: Map({
                regInfo: ReportBlockAccessRightRecord({
                    name: 'regInfo',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 5,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                addresses: ReportBlockAccessRightRecord({
                    name: 'addresses',
                    defaultLevel: '20',
                    isDisabled: false,
                    order: 7,
                    availableLevels: List(['20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                indicators: ReportBlockAccessRightRecord({
                    name: 'indicators',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 2,
                    availableLevels: List(['10']),
                    parameters: Map({
                        trade: true,
                        debt: true,
                    }),
                    flags: Map({}),
                }),
                syntheticIndicators: ReportBlockAccessRightRecord({
                    name: 'syntheticIndicators',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 3,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                bisnodeCertificates: ReportBlockAccessRightRecord({
                    name: 'bisnodeCertificates',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 1,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                companyAsCreditor: ReportBlockAccessRightRecord({
                    name: 'companyAsCreditor',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 21,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                liens: ReportBlockAccessRightRecord({
                    name: 'liens',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 19,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({
                        new: true,
                    }),
                }),
                activities: ReportBlockAccessRightRecord({
                    name: 'activities',
                    defaultLevel: '20',
                    isDisabled: false,
                    order: 9,
                    availableLevels: List(['20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                negativeEvents: ReportBlockAccessRightRecord({
                    name: 'negativeEvents',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 18,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                ownership: ReportBlockAccessRightRecord({
                    name: 'ownership',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 15,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                velikost: ReportBlockAccessRightRecord({
                    name: 'velikost',
                    defaultLevel: '20',
                    isDisabled: false,
                    order: 8,
                    availableLevels: List(['20']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                contacts: ReportBlockAccessRightRecord({
                    name: 'contacts',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 6,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                basicInformation: ReportBlockAccessRightRecord({
                    name: 'basicInformation',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 4,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
                persons: ReportBlockAccessRightRecord({
                    name: 'persons',
                    defaultLevel: '10',
                    isDisabled: false,
                    order: 10,
                    availableLevels: List(['10']),
                    parameters: Map({}),
                    flags: Map({}),
                }),
            }),
            parameters: Map({
                duns: true,
            }),
        }),
    }),
})

const transformPortfolioAccessRightsDataMock = Map({
    portfolios: Map({
        admin: PortfolioTypeAccessRightRecord({
            name: 'admin',
            isDisabled: false,
            isAllowed: true,
            order: 1,
            blocks: Map({
                block1: PortfolioBlockAccessRightRecord({
                    name: 'block1',
                    order: 1,
                    isDisabled: false,
                    defaultLevel: 50,
                    availableLevels: List([10, 30, 50]),
                }),
                block2: PortfolioBlockAccessRightRecord({
                    name: 'block2',
                    order: 2,
                    isDisabled: false,
                    defaultLevel: 30,
                    availableLevels: List([10, 30]),
                }),
                block3: PortfolioBlockAccessRightRecord({
                    name: 'block3',
                    order: 3,
                    isDisabled: false,
                    defaultLevel: 50,
                    availableLevels: List([10, 30, 50]),
                }),
                block4: PortfolioBlockAccessRightRecord({
                    name: 'block4',
                    order: 4,
                    isDisabled: false,
                    defaultLevel: 10,
                    availableLevels: List([10]),
                }),
                block5: PortfolioBlockAccessRightRecord({
                    name: 'block5',
                    order: 5,
                    isDisabled: true,
                    defaultLevel: 0,
                    availableLevels: List([]),
                }),
            }),
            export: List(['xls']),
            banner: List([]),
        }),
        kompletni: PortfolioTypeAccessRightRecord({
            name: 'kompletni',
            isDisabled: false,
            isAllowed: true,
            order: 2,
            blocks: Map({
                block1: PortfolioBlockAccessRightRecord({
                    name: 'block1',
                    order: 1,
                    isDisabled: false,
                    defaultLevel: 50,
                    availableLevels: List([10, 30, 50]),
                }),
                block2: PortfolioBlockAccessRightRecord({
                    name: 'block2',
                    order: 2,
                    isDisabled: false,
                    defaultLevel: 30,
                    availableLevels: List([10, 30]),
                }),
                block3: PortfolioBlockAccessRightRecord({
                    name: 'block3',
                    order: 3,
                    isDisabled: false,
                    defaultLevel: 50,
                    availableLevels: List([10, 30, 50]),
                }),
                block4: PortfolioBlockAccessRightRecord({
                    name: 'block4',
                    order: 4,
                    isDisabled: false,
                    defaultLevel: 10,
                    availableLevels: List([10]),
                }),
            }),
            export: List(['xls']),
            banner: List([]),
        }),
        podrobny: PortfolioTypeAccessRightRecord({
            name: 'podrobny',
            isDisabled: false,
            isAllowed: true,
            order: 3,
            blocks: Map({
                block1: PortfolioBlockAccessRightRecord({
                    name: 'block1',
                    order: 1,
                    isDisabled: false,
                    defaultLevel: 30,
                    availableLevels: List([10, 30]),
                }),
                block3: PortfolioBlockAccessRightRecord({
                    name: 'block3',
                    order: 2,
                    isDisabled: false,
                    defaultLevel: 30,
                    availableLevels: List([10, 30]),
                }),
                block4: PortfolioBlockAccessRightRecord({
                    name: 'block4',
                    order: 3,
                    isDisabled: false,
                    defaultLevel: 10,
                    availableLevels: List([10]),
                }),
            }),
            export: List(['xls']),
            banner: List(['upsellInline', 'upsellCarousel']),
        }),
        zakladni: PortfolioTypeAccessRightRecord({
            name: 'zakladni',
            isDisabled: false,
            isAllowed: true,
            order: 4,
            blocks: Map({
                block1: PortfolioBlockAccessRightRecord({
                    name: 'block1',
                    order: 1,
                    isDisabled: false,
                    defaultLevel: 10,
                    availableLevels: List([10]),
                }),
                block4: PortfolioBlockAccessRightRecord({
                    name: 'block4',
                    order: 2,
                    isDisabled: false,
                    defaultLevel: 10,
                    availableLevels: List([10]),
                }),
            }),
            export: List([]),
            banner: List(['upsellInline', 'upsellCarousel']),
        }),
    }),
})

describe('Authorization service helpers', () => {
    test('transformReportAccessRightsData', () => {
        const transformedData = transformReportAccessRightsData(accessRightsReport.types)

        expect(transformedData).toEqual(transformReportAccessRightsDataMock)
    })

    test('transformPortfolioAccessRightsData', () => {
        const transformedData = transformPortfolioAccessRightsData(accessRightsPortfolio.types)

        expect(transformedData).toEqual(transformPortfolioAccessRightsDataMock)
    })
})
